import React from 'react'
import CustomModal from 'app/components/CustomModal'
import useCrispChat from 'app/Hooks/useCrispChat'
import Button from 'app/components/Button'

interface UpgradeModalProps {
  show: boolean
  onClose: () => void
}

const UpgradePlanTest: React.FC<UpgradeModalProps> = ({show, onClose}) => {
  const {toggleCrispChat} = useCrispChat()
  if (!show) {
    return null
  }

  return (
    <CustomModal show={show} onClose={onClose}>
      <p className='fw-bold mb-5 fs-1 text-gray-900'>Unlock this Feature with a Paid Plan</p>{' '}
        <p className='mb-6 fs-6 text-gray-900'>
          {' '}
          Upgrade to any paid plan to continue enjoying this feature. Check out the{' '}
          <a
            href='https://getsecureslate.com/pricing'
            className='text-primary text-decoration-none'
            target='_blank'
            rel='noreferrer'
          >
            {' '}
            pricing details{' '}
          </a>{' '}
          for more information.{' '}
        </p>
        <p className='mb-8 fs-6 text-gray-900'>
         <strong>Note:</strong> If you are on a paid plan, this feature is mapped to the corresponding test, providing an
          overview of the test status and allowing you to easily navigate to the associated test.
        </p>
        <div className='d-flex justify-content-center mb-3'>
            <Button onClick={toggleCrispChat} btnType='primary' style={{width: '100%'}}>
              Contact Sales
            </Button>
          </div>

          <p className='small text-center text-gray-900 fs-7'>
            Risk-free for 30 days. 100% money-back guarantee.
          </p>
    </CustomModal>
  )
}

export default UpgradePlanTest
